import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Preloader from './components/Preloader';
import DriverForm from './components/DriverForm';
import AdminLogin from './components/AdminLogin';
import AdminDashboard from './components/AdminDashboard';
import DocumentList from './components/DocumentList';
import logo from './assets/logo/logo.png';
import banniere from './assets/images/banniere.jpg';
import './App.css';

const PrivateRoute = ({ children }) => {
  const isAdmin = localStorage.getItem('isAdmin') === 'true';
  return isAdmin ? children : <div className="text-center py-5"><h3>Accès refusé. Veuillez vous connecter.</h3><a href="/admin/login" className="btn btn-dark mt-3">Aller à la connexion</a></div>;
};

const SuccessRoute = ({ children, formSubmitted }) => {
  return formSubmitted ? children : <div className="text-center py-5"><h3>Accès refusé. Veuillez remplir le formulaire d'abord.</h3><a href="/" className="btn btn-warning mt-3">Aller au formulaire</a></div>;
};

const AppContent = ({ formSubmitted, setFormSubmitted }) => {
  const location = useLocation();
  // On passe tout en minuscule pour éviter les erreurs de casse
  const path = location.pathname.toLowerCase();
  
  const isAdminPath = path.startsWith('/admin');
  // On vérifie si "documents" est présent dans l'URL
  const isSuccessPage = path.includes('documents');

  // Si c'est la page de succès, on ne veut absolument RIEN en haut
  if (isSuccessPage) {
    return (
      <div className="App d-flex flex-column min-vh-100 bg-light">
        <main className="container flex-grow-1 py-5">
          <Routes>
            <Route path="/documents" element={
              <SuccessRoute formSubmitted={formSubmitted}>
                <DocumentList />
              </SuccessRoute>
            } />
          </Routes>
        </main>
        <footer className="footer mt-auto py-3 bg-light text-center border-top">
          <div className="container">
            <span className="text-muted small">© 2026 Pax Driver. Tous droits réservés.</span>
          </div>
        </footer>
      </div>
    );
  }

  // Pour les autres pages (Accueil ou Admin)
  return (
    <div className="App d-flex flex-column min-vh-100 bg-light">
      {!isAdminPath ? (
        <header className="profile-header position-relative">
          <div className="cover-photo shadow-sm" style={{ backgroundImage: `url(${banniere})` }}>
            <div className="container h-100 position-relative"></div>
          </div>
          <div className="container position-relative">
            <div className="profile-logo-container">
              <div className="profile-logo-wrapper shadow-lg">
                <img src={logo} alt="Pax Driver Logo" className="profile-logo-img" />
              </div>
              <div className="profile-info-text ms-3 mb-2">
                <h1 className="fw-bold text-uppercase mb-0 text-dark" style={{ letterSpacing: '1px', fontSize: '1.5rem' }}>
                  Pax <span className="text-warning">Driver</span>
                </h1>
                <p className="text-muted small mb-0 fw-semibold">Partenaire Professionnel de Transport</p>
              </div>
            </div>
          </div>
        </header>
      ) : (
        <nav className="navbar navbar-expand-lg navbar-dark bg-dark shadow-sm py-2">
          <div className="container">
            <a className="navbar-brand d-flex align-items-center" href="/">
              <img src={logo} alt="Pax Driver Logo" style={{ height: '35px' }} className="me-2" />
              <span className="fw-bold text-uppercase text-warning" style={{ fontSize: '0.9rem' }}>Pax Driver Admin</span>
            </a>
            <div className="navbar-nav ms-auto">
              <a className="nav-link small" href="/" style={{ fontSize: '0.8rem' }}>Retour au site</a>
            </div>
          </div>
        </nav>
      )}

      <main className={`container flex-grow-1 ${!isAdminPath ? 'profile-content' : 'py-5'}`}>
        <Routes>
          <Route path="/" element={
            <div className="row justify-content-center">
              <div className="col-md-8 col-lg-6">
                <DriverForm onSchemaSubmit={() => setFormSubmitted(true)} />
              </div>
            </div>
          } />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={
            <PrivateRoute>
              <AdminDashboard />
            </PrivateRoute>
          } />
        </Routes>
      </main>
      
      <footer className="footer mt-auto py-3 bg-light text-center border-top">
        <div className="container">
          <span className="text-muted small">© 2026 Pax Driver. Tous droits réservés.</span>
        </div>
      </footer>
    </div>
  );
};

function App() {
  const [loading, setLoading] = useState(true);
  const [formSubmitted, setFormSubmitted] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 3000);
    return () => clearTimeout(timer);
  }, []);

  if (loading) return <Preloader />;

  return (
    <Router>
      <AppContent formSubmitted={formSubmitted} setFormSubmitted={setFormSubmitted} />
    </Router>
  );
}

export default App;
